$(function (ws) {
    ws.views.customerOnboardingMDMValidation = ws.views.modal.extend({
        events: {
            'click .cancel-event': 'closeModal',
            'click button.address-suggestion, input[type="button"].address-suggestion': 'submitUserSelection'
        },

        /**
         * Initialize the component.
         */
        initialize: function () {
            ws.views.modal.prototype.initialize.call(this);
            this.$modalBody = this.$('.modal-body');
            this.eventAgg.on('accountAddAddressCustomerOnBoarding:open', this.bindModel, this);
            this.$addAddressTemplate = $('#add-address-template');
            this.$showAddressTemplate = $('#show-address-template');
            this.$typeAddressTemplate = $('#type-address-template');
            this.template = _.template(this.$addAddressTemplate.html());
            this.addressNames = {};
        },

        closeModal: function () {
            this.eventAgg.trigger('mdmClose', this.numberOfRequest === this.successAddressCount);

            // trigger super closeModal
            ws.views.modal.prototype.closeModal.call(this);
        },

        /**
         * This function will submit user selection based on entered address and suggestions.
         */
        submitUserSelection: function (e) {
            var prop = $(e.currentTarget).data('address');
            var api = $(e.currentTarget).data('api');
            var account = new ws.models.accountDetails(prop);
            let subData = {
                accountName:account.get('accountName'),
                addressLine1:account.get('addressLine1'),
                addressLine2:account.get('addressLine2'),
                addressLine3:account.get('addressLine3'),
                addressLine4:account.get('addressLine4'),
                locality:account.get('locality'),
                city:account.get('town'),
                zipCode:account.get('zipCode'),
                state: account.get('country').isocode + '-' + account.get('state'),
                phone:account.get('phone'),
                fax:account.get('fax'),
                industry:account.get('industry'),
                country:account.get('country').isocode
            };

            let address = $(e.currentTarget).parent().parent().parent();
            $(address).find('.reformatted-address').addClass('hide');
            $(address).find('.entered-address').addClass('hide');

            if ($(e.currentTarget).attr('id') === 'reformatedAddressButton') {
                $(address).find('.reformatedMessage').removeClass('hide');
                let mdmParams = ['accountName', 'addressLine1', 'addressLine2', 'addressLine3', 'addressLine4', 'locality', 'city', 'zipCode', 'phone', 'fax', 'industry', 'type', 'language'];
                let htmlParams = ['company', 'streetname', 'streetnumber', 'building', 'line3', 'line4', 'town', 'postalcode', 'phone1', 'fax', 'industry', 'type', 'language'];

                _.each($('.' + api), function (items) {
                    if ($(items).attr('name')) {
                        let requiredAttr = '';
                        if (htmlParams.includes($(items).attr('name'))) {
                            requiredAttr = mdmParams[htmlParams.indexOf($(items).attr('name'))];
                            if (subData[requiredAttr]) {
                                $(items).val(subData[requiredAttr]).trigger('change');
                            }
                        }
                    }
                });
            } else {
                $(address).find('.enteredMessage').removeClass('hide');
            }
        },

        /**
         * This function will show the response got from add address API(checking)
         */
        bindModel: function (responseObj, addressList, noOfRequests, addressNames) {
            let data = {};
            this.addressNames = addressNames;
            this.$modalBody.find('.placeHolder:first').replaceWith(this.template());
            this.$modalBody.find('.typeOfAddress').html('');
            this.dependendAddressCount = 0;
            this.successAddressCount = 0;
            this.numberOfRequest = noOfRequests;

            _.each(responseObj, (obj) => {
                data[obj.addressName] = obj.addressResponse;
            });

            _.each(addressList, (addr) => {
                if (data[addr]) {
                    this.setAddress(data[addr], addr);
                }
            });

            $('.enteredMessage').addClass('hide');
            $('.reformatedMessage').addClass('hide');

            if ((noOfRequests !== this.dependendAddressCount) && (this.dependendAddressCount !== addressList.length)) {
                this.onOpen();
            }
        },

        /**
         * This function will set data properties.
         */
        setDataProperties: function(dataAddress, buttonElementId, enteredAddDiv, _this, type) {
            var accountEntered;

            if (dataAddress !== undefined && dataAddress !== null) {
                accountEntered = new ws.models.accountDetails(dataAddress);
                var addressType = buttonElementId === '#userEnteredAddressButton' ? 'Entered Address' : 'Reformatted Address';
                enteredAddDiv.html(_.template(_this.$showAddressTemplate.html())(this.setAddressData(accountEntered, addressType)));
                var buttonElement = enteredAddDiv.find(buttonElementId);
                buttonElement.attr('data-address', JSON.stringify(accountEntered.toJSON()).replace(/'/g, '&#39;'));
                buttonElement.attr('data-api', type);
            }
        },

        /**
         * This function return empty string for null
         */
        getAddressVal: function(text) {
            if (text !== undefined && text !== null && text !== '') {
                text = text + ', ';
            } else {
                text = '';
            }

            return text;
        },

        /**
         * This function will set data for add address post.
         */
        setAddressData: function(accountObj, accountType) {
            var addData = {
                type: accountType,
                sapId: this.getAddressVal(accountObj.get('sapId')),
                name: this.getAddressVal(accountObj.get('accountName')),
                address1: this.getAddressVal(accountObj.get('addressLine1')),
                address2: this.getAddressVal(accountObj.get('addressLine2')),
                address3: this.getAddressVal(accountObj.get('addressLine3')),
                address4: this.getAddressVal(accountObj.get('addressLine4')),
                locality: this.getAddressVal(accountObj.get('locality')),
                city: this.getAddressVal(accountObj.get('town')),
                state: this.getAddressVal(accountObj.get('state')),
                zip: this.getAddressVal(accountObj.get('zipCode')),
                country: accountObj.get('country').isocode
            };
            return addData;
        },

        setAddress: function(data, addressName) {
            if (data) {
                if (data.error) {
                    this.dependendAddressCount = this.dependendAddressCount + 1;

                    let $errorMessage = $('.' + addressName)[0];
                    $($errorMessage).find('ul').remove();
                    let regError = '<ul>';
                    _.each(data.errors, function (error) {
                        regError += '<li class="mdm-error-border">' + error.message + '</li>';
                    });
                    regError += '</ul>';
                    if ($($errorMessage).parent().parent().hasClass('hiddenLabel')) {
                        $($errorMessage).parent().parent().removeClass('hiddenLabel');
                        $($errorMessage).html('');
                    }

                    $($errorMessage).append(regError);
                    this.eventAgg.trigger('showTabLevelError');
                } else if (data.reformatted !== undefined && data.reformatted !== null) {
                    this.successAddressCount = this.successAddressCount + 1;
                    let accountReformated = new ws.models.accountDetails(data.reformatted);
                    this.typeTemplate = _.template(this.$typeAddressTemplate.html());
                    this.$modalBody.find('.typeOfAddress').append(this.typeTemplate({type: addressName + 'Data'}));
                    let currentAddressDiv = this.$modalBody.find('.' + addressName + 'Data');

                    if (this.addressNames[addressName]) {
                        currentAddressDiv.find('.addressName').html(this.addressNames[addressName]);
                    } else {
                        currentAddressDiv.find('.addressName').html(addressName);
                    }

                    this.setDataProperties(data.entered, '#userEnteredAddressButton', currentAddressDiv.find('.entered-address'), this, addressName);
                    this.setDataProperties(data.reformatted, '#reformatedAddressButton', currentAddressDiv.find('.reformatted-address'), this, addressName);
                    let $Message = $('.' + addressName)[0];
                    $($Message).find('ul').remove();

                    let reg = '<span style="display:none">MDM Verfied</span>';
                    $($Message).append(reg);
                    this.eventAgg.trigger('showTabLevelError');
                }
            }
        }
    });
}(westcon));

